<template>
  <div>
    <div class="searchBox">
      <div class="searchLeft">
        <el-input
          size="medium"
          v-model="searchForm.tel"
          placeholder="请输入手机号"
          type="text" @input="searchForm.tel = String(searchForm.tel).replace(/[^\d]/g,'')"   ng-pattern="/[^a-zA-Z]/"
          @keyup.enter.native="getTableList"
        ></el-input>
        <el-input
          size="medium"
          v-model="searchForm.sysUserId"
          placeholder="请输入用户ID"
          type="text" @input="searchForm.sysUserId = String(searchForm.sysUserId).replace(/[^\d]/g,'')"   ng-pattern="/[^a-zA-Z]/"
          @keyup.enter.native="getTableList"
        ></el-input>
        <el-input
          size="medium"
          v-model="searchForm.userName"
          placeholder="请输入真实姓名"
          @keyup.enter.native="getTableList"
        ></el-input>
        <el-input
          size="medium"
          v-model="searchForm.email"
          placeholder="请输入邮箱"
          @keyup.enter.native="getTableList"
        ></el-input>
        <el-button size="medium" type="primary" icon="el-icon-search" @click="getTableList">查询</el-button>
      </div>
    </div>
    <el-table
      border
      :data="tableData"
      height="73vh"
      style="width: 100%">
      <el-table-column
        prop="createTime"
        width="160px"
        label="注册时间">
        <template slot-scope="scope">
          <span>{{$selfFunc.dayjsFunc(scope.row.createTime)}}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="sysUserId"
        width="80px"
        label="用户ID">
      </el-table-column>
      <el-table-column
        prop="userName"
        width="100px"
        label="姓名">
      </el-table-column>
      <el-table-column
        prop="phone"
        label="电话">
      </el-table-column>
      <el-table-column
        prop="email"
        width="200px"
        label="邮箱">
      </el-table-column>
      <el-table-column
        prop="invitationCode"
        label="推荐人">
      </el-table-column>
      <el-table-column
        prop="purchasedPower"
        label="已购买算力">
      </el-table-column>
      <el-table-column
      label="允许充币">
      <template slot-scope="scope">
        <div>
          <el-switch
          @change="ChangeTypeIsDel(scope.row)"
          v-model="scope.row.isDelCheck"
          active-color="#67c23a"
          inactive-color="#999">
          </el-switch>
        </div>
      </template>
    </el-table-column>
    <el-table-column
      label="允许提币">
      <template slot-scope="scope">
        <div>
          <el-switch
          @change="ChangeTypeIsDel(scope.row)"
          v-model="scope.row.isSellCheck"
          active-color="#67c23a"
          inactive-color="#999">
          </el-switch>
        </div>
      </template>
    </el-table-column>
      <el-table-column
        fixed="right"
        width="400px"
        label="操作">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="detaills(scope.row)"><i class="el-icon-view" style="margin-right:3px;" ></i>查看详情</el-button>
          <el-button size="mini" type="primary" @click="userback(scope.row)"><i class="el-icon-view" style="margin-right:3px;"></i>账户资产</el-button>
          <el-button size="mini" type="primary" @click="changeMoney(scope.row)"><i class="el-icon-view" style="margin-right:3px;"></i>提币记录</el-button>
          <el-button size="mini" type="primary" @click="mention(scope.row)"><i class="el-icon-view" style="margin-right:3px;"></i>充币记录</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pageBox" v-if="totalNum > 0">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchForm.page"
        :page-sizes="[15, 50, 100, 500]"
        :page-size="searchForm.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
      >
      </el-pagination>
    </div>
    <el-dialog
      title="基本信息"
      :visible.sync="dialogVisible"
      width="800px">
      <div class="userInfo_box">
        <div class="sam_box">
          <div>用户ID: {{userInfo.sysUserId}}</div>
          <div>邀请码: {{userInfo.inviteCode}}</div>
          <div>注册时间: {{$selfFunc.dayjsFunc(userInfo.createTime)}}</div>
        </div>
        <div class="sam_box">
          <div>手机号: {{userInfo.phone}}</div>
          <div>邮箱: {{userInfo.email}}</div>
          <div>来源: --</div>
        </div>
        <div class="sam_box">
          <div>推荐人: {{userInfo.invitationCode}}</div>
          <div>渠道名称: {{userInfo.channelName}}</div>
          <div>待封装算力: {{userInfo.unpackagedPower}} TiB</div>
        </div>
      </div>
      <div class=""></div>
    </el-dialog>
    <el-dialog
      title="充币记录"
      :visible.sync="dialogVisibleTwo"
      width="1200px">
      <div class="table_box">
        <el-table
          border
          :data="tableDataTwo"
          height="44vh"
          style="width: 100%">
          <el-table-column
            prop="id"
            label="订单号">
          </el-table-column>
          <el-table-column
            prop="coinName"
            width="80px"
            label="币种">
          </el-table-column>
          <el-table-column
            prop="linkName"
            width="80px"
            label="链路">
          </el-table-column>
          <el-table-column
            prop="value"
            width="80px"
            label="充币数量">
          </el-table-column>
          <el-table-column
          width="350px"
            prop="to"
            label="充币地址">
          </el-table-column>
          <el-table-column
            width="100px"
            label="充币状态">
            <template slot-scope="scope">
              <span>{{scope.row.state=='DONE'?"充币成功":scope.row.state=='PENDING'?'充币中':"充币失败"}}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="充币时间">
            <template slot-scope="scope">
              <span>{{$selfFunc.dayjsFunc(scope.row.doneTime)}}</span>
            </template>
          </el-table-column>
        </el-table>
        <div class="pageBox" v-if="totalTwoNum > 0">
          <el-pagination
            background
            @size-change="handleSizeChangeTwo"
            @current-change="handleCurrentChangeTwo"
            :current-page="searchFormTwo.page"
            :page-sizes="[10]"
            :page-size="searchFormTwo.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalTwoNum"
          >
          </el-pagination>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      title="提币记录"
      :visible.sync="dialogVisibleThr"
      height="60vh"
      width="1300px">
      <div class="table_box">
        <el-table
          border
          :data="tableDataThr"
          height="44vh"
          style="width: 100%">
          <el-table-column
            prop="id"
            label="订单号">
          </el-table-column>
          <el-table-column
            prop="coinName"
            width="100px"
            label="币种">
          </el-table-column>
          <el-table-column
            prop="linkName"
            width="80px"
            label="链路">
          </el-table-column>
          <el-table-column
            prop="value"
            width="80px"
            label="提币数量">
          </el-table-column>
          <el-table-column
            prop="actualFee"
            width="80px"
            label="手续费">
          </el-table-column>
          <el-table-column
            width="400px"
            prop="walletAddr"
            label="提币地址">
          </el-table-column>
          <el-table-column
            width="100px"
            label="提币状态">
            <template slot-scope="scope">
              <span>{{scope.row.transStatus=='DONE'?"提币成功":scope.row.transStatus=='PENDING'?'提币中':"提币失败"}}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="提币时间">
            <template slot-scope="scope">
              <span>{{$selfFunc.dayjsFunc(scope.row.applyTime)}}</span>
            </template>
          </el-table-column>
        </el-table>
        <div class="pageBox" v-if="totalThrNum > 0">
          <el-pagination
            background
            @size-change="handleSizeChangeThr"
            @current-change="handleCurrentChangeThr"
            :current-page="searchFormThr.page"
            :page-sizes="[10]"
            :page-size="searchFormThr.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalThrNum"
          >
          </el-pagination>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      title="账户信息"
      :visible.sync="dialogVisibleFour"
      width="1000px">
      <div class="table_box">
        <div class="listBox">
          <div class="list_samll_box" style="height:40px;line-height:40px">
            <div>币种</div>
            <div>总金额</div>
            <div>冻结金额</div>
            <div>可用余额</div>
            <div>质押金额</div>
            <div>公链</div>
            <div>钱包地址</div>
          </div>
          <div class="list_samll_box"  v-for="(item,index) in userbackLists" :key="index">
            <div>{{item.coinName}}</div>
            <div>{{$selfFunc.toNonExponential(item.totalBalance,4)}}</div>
            <div>{{$selfFunc.toNonExponential(item.frozenNum,4)}}</div>
            <div>{{$selfFunc.toNonExponential(item.balance,4)}}</div>
            <div>{{$selfFunc.toNonExponential(item.totalPledge,4)}}</div>
            <div style="width:442px">
              <div v-for="(items) in item.appCoinUserList" :key="items.linkName" class="divTst">
                <div style="width: 130px;" >{{items.linkName}}</div>
                <div  style="width: 460px;">{{items.address}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      totalNum:0,
      searchForm:{
        page:1,
        pageSize:15,
        isLoginBack:0,
        tel: '',
        email: '',
        userName:'',
        sysUserId: ''
      },
      tableData: [],
      dialogVisible: false,
      dialogVisibleTwo: false,
      dialogVisibleThr: false,
      dialogVisibleFour: false,
      userInfo: {},
      searchFormTwo:{
        page:1,
        pageSize:10,
        userId: ''
      },
      tableDataTwo:[],
      totalTwoNum:0,

      searchFormThr:{
        page:1,
        pageSize:10,
        userId: ''
      },
      tableDataThr:[],
      totalThrNum:0,
      userId:'',
      userbackLists:[]
    };
  },
  created() {
    this.getTableList()
  },
  methods: {
    async ChangeTypeIsDel(row){
      console.log(row)
      let data= {
        insideUserId: row.sysUserId,
        depositStatus: row.isDelCheck?1:0,
        withdrawStatus: row.isSellCheck?1:0
      }
      let res = await this.$http.openOrClose(data);
      if (res) {
        this.$message.success('操作成功！');
        this.getTableList()
      } 
    },
    userback(row){
      this.userId=row.sysUserId
      this.getUserback()
    },
    async getUserback(){
      let res = await this.$http.userbackList({insideUserId:this.userId});
      if (res) {
        this.userbackLists = res.data.detailList
        this.dialogVisibleFour = true
      }
    },
    changeMoney(row) {
      this.searchFormThr.userId = row.sysUserId
      this.tMoneyList()
    },
    async tMoneyList() {
      let res = await this.$http.listPageForAdmin({...this.searchFormThr});
      if (res) {
        this.tableDataThr=res.data.list
        console.log(res.data)
        this.totalThrNum=Number(res.data.totalSize)
        this.dialogVisibleThr=true
      }
    },
    mention(row) {
      this.searchFormTwo.userId = row.sysUserId
      this.mentionList()
    },
    async mentionList() {
      let res = await this.$http.listChargePage({...this.searchFormTwo});
      if (res) {
        this.tableDataTwo=res.data.list
        console.log(res.data)
        this.totalTwoNum=Number(res.data.totalSize)
        this.dialogVisibleTwo=true
      }
    },
    detaills(row) {
      console.log(row)
      this.userInfo = row
      this.dialogVisible=true
    },
    async getTableList(val){
      if(val){
        this.searchForm.page=1;
      }
       let res = await this.$http.userList({...this.searchForm});
        if (res) {
          this.tableData=res.data.list.map(x=>{
              if(x.depositStatus==1){
                x.isDelCheck=true
              } else {
                x.isDelCheck=false
              }
              if(x.withdrawStatus==1){
                x.isSellCheck=true
              } else {
                x.isSellCheck=false
              }
              return x
          })
          console.log(this.tableData)
          this.totalNum = Number(res.data.totalSize)
        }
    },
    handleSizeChange(val) {
      this.searchForm.page = 1;
      this.searchForm.pageSize = val;
      this.getTableList();
    },
    handleCurrentChange(val) {
      this.searchForm.page = val;
      this.getTableList();
    },

    handleSizeChangeTwo(val) {
      this.searchFormTwo.page = 1;
      this.searchFormTwo.pageSize = val;
      this.mentionList();
    },
    handleCurrentChangeTwo(val) {
      this.searchFormTwo.page = val;
      this.mentionList();
    },

    handleSizeChangeThr(val) {
      this.searchFormThr.page = 1;
      this.searchFormThr.pageSize = val;
      this.tMoneyList();
    },
    handleCurrentChangeThr(val) {
      this.searchFormThr.page = val;
      this.tMoneyList();
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        return {
          rowspan: row.rowspan,
          colspan: 1
        };
      }
    }
  }
};
</script>

<style scoped>
.listBox{
  border: 1px solid #ddd;
  border-bottom: none;
}
.list_samll_box{
  display: flex;
  align-items: center;
  padding:10px;
  border-bottom: 1px solid #dddd;
}
.list_samll_box>div {
  width: 100px;
}
.divTst{
  display: flex;
  align-items: center;
  margin-bottom: 10xp;
}
.divTst:last-child{
  margin: 0;
}
.sam_box{
  display: flex;
  align-items: center;
  /* justify-content: space-between; */
  margin-bottom: 20px;
}
.sam_box div{
  width: 210px;
  margin-right: 60px;
}
.sam_box div:nth-child(3n){
  margin-right: 0;
}
.table_box{
  height: 500px;
}
</style>
